
// export const globalSrc  = 'http://192.168.1.110:5001'
export const globalSrc  = 'https://www.lthj.tech:443'




